export default "__VITE_ASSET__sXYimtRw__"